// Extrait de NursePatientDetail / DoctorPatientDetail (handover bloc F2, B6) — fermeture puis rafraîchissement, ordre inchangé.
import { TreatmentEvolutionModal, DiseaseProgressionModal, ClinicalEventModal } from "@/components/clinical/ClinicalUpdateModals";

export default function PatientClinicalUpdateModals({
  patientId,
  patient,
  showTreatmentEvolution,
  showDiseaseProgression,
  showClinicalEvent,
  onCloseTreatmentEvolution,
  onCloseDiseaseProgression,
  onCloseClinicalEvent,
  onRefresh,
}) {
  return (
    <>
      {showTreatmentEvolution && (
        <TreatmentEvolutionModal
          patientId={patientId}
          currentData={patient}
          onClose={onCloseTreatmentEvolution}
          onUpdated={() => { onCloseTreatmentEvolution(); onRefresh(); }}
        />
      )}
      {showDiseaseProgression && (
        <DiseaseProgressionModal
          patientId={patientId}
          currentData={patient}
          onClose={onCloseDiseaseProgression}
          onUpdated={() => { onCloseDiseaseProgression(); onRefresh(); }}
        />
      )}
      {showClinicalEvent && (
        <ClinicalEventModal
          patientId={patientId}
          patientName={patient ? `${patient.firstName} ${patient.lastName}` : undefined}
          onClose={onCloseClinicalEvent}
          onUpdated={() => { onCloseClinicalEvent(); onRefresh(); }}
        />
      )}
    </>
  );
}
